export const USER_REGISTERED = "USER_REGISTERED";
export const USER_LOGOUT = "USER_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const CURRENCY_LOADING = "CURRENCY_LOADING";
export const CURRENCY_LOADED = "CURRENCY_LOADED";
export const PORTFOLIO_START = "PORTFOLIO_START";
export const CURRENCY_RATE = "CURRENCY_RATE";
export const GET_TOTAL = "GET_TOTAL";
export const FROM_CURRENCY = "FROM_CURRENCY";
export const TO_CURRENCY = "TO_CURRENCY";
export const CLEAR_RATE = "CLEAR_RATE";
export const SELL_CURRENCY = "SELL_CURRENCY";
export const BUY_CURRENCY = "BUY_CURRENCY";
export const UNSUFFICENT_BALANCE = "UNSUFFICENT_BALANCE";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const ADD_CURRENCY = "ADD_CURRENCY";
export const CURRENCY_DAILY_START = "CURRENCY_DAILY_START";
export const CURRENCY_NEWS = "CURRENCY_NEWS";
